module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige14-dca79360883bf43b3f61355827851350.jpg";